import React from "react";
import { useTranslation } from "react-i18next";
import { SharedEventList } from "./sharedEventList";

/**
 * HSE/KS Complaints List - Customer complaints (ISO 9001:2015)
 */
export const HseKsComplaintsList = () => {
  const { t } = useTranslation();

  return (
    <SharedEventList
      activeTab="complaints"
      title="Reklamasjoner"
      subtitle="Oversikt over kundereklamasjoner (ISO 9001:2015 - kap. 10.2)"
      newButtonLabel={t("Ny reklamasjon")}
      newButtonPath="/dashboard/hse-ks/events/new?type=complaint"
      emptyMessage={t("Ingen reklamasjoner funnet")}
      searchPlaceholder={t("Søk i reklamasjoner...")}
      defaultFilters={{
        event_category: "other",
      }}
    />
  );
};

